'use strict';

/* global $ */
/* global _ */

/**
 * Обработчк для адаптивного меню в шапке
 * @param {Object} options хеш параметров.
 * Параметры:
 *     selector - элемент, в котором находится меню
 *     toggler - элемент переключатель меню
 *     active - название класса при котором меню должно быть показано
 *     togglerActive - название класса активности для переключателя
 *     closeOnBody - закрывать по клику на область вне меню
 *     toggleText - менять текст на переключателе
 *     activeText - текст на переключателе при активированном меню
 *     defaultText - текст на переключателе по умолчанию
 *     togglerTextBlock - класс блока с текстом в переключателе (опционально)
 */
function ResponsiveMenu(options){
    var opt = _.extend({ }, { selector: '.js-header-responsive',
                              toggler: '.js-header-toggler',
                              active: 'is-active',
                              togglerActive: 'is-active',
                              fixedWrap: 'wrap-fixed',
                              closeOnBody: true,
                              toggleText: false,
                              activeText: '',
                              defaultText: '',
                              togglerTextBlock: '',
                              noLock: false }, options);
    var $wrap = $(opt.selector);
    var $toggler = $(opt.toggler);
    var $togglerText = $();

    if(($wrap.length) && ($toggler.length)){
        if(opt.toggleText){
            if(opt.togglerTextBlock !== ''){
                $togglerText = $toggler.find(opt.togglerTextBlock);
            }else{
                $togglerText = $toggler;
            }
            if(($togglerText.length > 0) && (opt.defaultText === '')){
                opt.defaultText = $togglerText.text();
            }

            toggleText();
        }

        $toggler.on('click', function(e){
            e.preventDefault();

            $(this).toggleClass(opt.togglerActive);

            toggleMenu();
            toggleText();
        });

        if(opt.closeOnBody){
            $wrap.on('click', function(e){
                e.stopPropagation();
            });

            $('body').on('click', function(){
                hideMenu();
                toggleText();
            });
        }

        if(!opt.noLock){
            $(window).on('resize', function(){
                var width = window.innerWidth
                    || document.documentElement.clientWidth
                    || document.body.clientWidth;

                if(width > 1000){
                    hideMenu();
                    toggleText();
                }
            });
        }

    }

    function toggleMenu(){
        $wrap.toggleClass(opt.active);
        checkLock();
    }

    function hideMenu(){
        if($wrap.hasClass(opt.active)){
            $toggler.removeClass(opt.togglerActive);
            $wrap.removeClass(opt.active);
            checkLock();
        }
    }

    function checkLock(){
        if(!opt.noLock){
            if($wrap.hasClass(opt.active)){
                $wrap.parent().wrap('<div class="'+opt.fixedWrap+'"></div>');
                $('html').addClass('html-lock');
            }else{
                $wrap.parent().unwrap();
                $('html').removeClass('html-lock');
            }
        }
    }

    function toggleText(){
        if($togglerText.length > 0){
            if($wrap.hasClass(opt.active)){
                $togglerText.html(opt.activeText);
            }else{
                $togglerText.html(opt.defaultText);
            }
        }
    }
}

export {
    ResponsiveMenu
};